<template>
  <div class="header">
    <div class="h1">{{title?title:'优化供应链 降低成本'}}</div>
    <div class="h2"><span style="width:550px;display: inline-block;">{{desc?desc:'汇聚集群需求，整合优质资源，通过规模化采购实现成本节约与高效供应'}}</span></div>
  </div>
</template>

<script>
export default {
  name: "jzcgheader",
  props:['title','desc']
}
</script>

<style lang="scss" scoped>
.header{
  height: 220px;
  background: url("../../assets/banner/jzcg.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 90px;
  text-align: center;
  color: #fff;
  .h1{
    font-size: 42px;
    font-weight: 500;
    text-align: left;
    width:1200px;
    margin:0 auto;
    margin-top:20px;
  }
  .h2{

    font-size: 24px;
    // line-height: 80px;
    line-height: 35px;
    text-align: left;
    width:1200px;
    margin:0 auto;
    padding-top:10px;
  }
}
</style>